import { ScaleBand, scaleBand } from "d3";
import { uniq } from "lodash";
import { useMemo } from "react";

import { MarkerPlayer } from "../../../types";

const PLAYER_BAR_HEIGHT = 30;

export interface UseGetPlayerScaleProps {
  players: MarkerPlayer[];
  height: number;
}

export const useGetPlayerScale = ({ players, height }: UseGetPlayerScaleProps): ScaleBand<string> => {
  return useMemo((): ScaleBand<string> => {
    const playerDomain = uniq(players.map((player) => player.id));
    const rangeMax = Math.min(PLAYER_BAR_HEIGHT * playerDomain.length, height);
    return scaleBand().domain(playerDomain).range([0, rangeMax]).paddingInner(0.2);
  }, [players, height]);
};
